import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fmtDate } from "@/components/shared";
import { Phone, CalendarClock, CheckCircle2 } from "lucide-react";

export default function MyDay() {
  const navigate = useNavigate();
  const { data } = useQuery({ queryKey: ["my-day"], queryFn: async () => (await api.get("/reports/my-day")).data, refetchInterval: 60000 });
  const followups = data?.followups || [];
  const appts = data?.appointments || [];
  return (
    <div className="mt-6 grid lg:grid-cols-2 gap-4" data-testid="my-day">
      <div className="rounded-xl border bg-white dark:bg-slate-800 p-5">
        <div className="flex items-center gap-2 font-head font-bold mb-3"><Phone className="w-4 h-4 text-orange-600" /> Today's follow-up calls <span className="text-sm text-slate-400">({followups.length})</span></div>
        {followups.length === 0 ? <p className="text-sm text-slate-400">No calls due today. 🎉</p> : (
          <div className="space-y-2 max-h-72 overflow-y-auto">
            {followups.map((f) => (
              <div key={f.id} className="flex items-center justify-between gap-2 p-2 rounded-lg bg-slate-50 dark:bg-slate-900 cursor-pointer hover:bg-slate-100" onClick={() => navigate(`/leads?id=${f.lead_id}`)} data-testid={`myday-fu-${f.id}`}>
                <div><div className="font-medium text-sm">{f.lead_name || "Lead"}</div><div className="text-xs text-slate-500">{f.phone} · {fmtDate(f.due_at)}</div></div>
                <CheckCircle2 className="w-4 h-4 text-slate-300" />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="rounded-xl border bg-white dark:bg-slate-800 p-5">
        <div className="flex items-center gap-2 font-head font-bold mb-3"><CalendarClock className="w-4 h-4 text-blue-600" /> Today's appointments <span className="text-sm text-slate-400">({appts.length})</span></div>
        {appts.length === 0 ? <p className="text-sm text-slate-400">No appointments today.</p> : (
          <div className="space-y-2 max-h-72 overflow-y-auto">
            {appts.map((a) => (
              <div key={a.id} className="flex items-center justify-between gap-2 p-2 rounded-lg bg-slate-50 dark:bg-slate-900 cursor-pointer hover:bg-slate-100" onClick={() => navigate("/appointments")} data-testid={`myday-appt-${a.id}`}>
                <div><div className="font-medium text-sm">{a.lead_name} <span className="text-[10px] text-slate-400">· {a.kind}</span></div><div className="text-xs text-slate-500">{fmtDate(a.scheduled_at)}</div></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
